<template>
  <a-modal
    title="新增标签"
    :width="520"
    :visible="visible"
    :destroyOnClose="true"
    :keyboard="false"
    :maskClosable="false"
    @cancel="close"
  >
    <a-spin :spinning="loading">
      <div class="container">
        <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="所属上级标签" v-if="parentInfo.name">
            {{ parentInfo.name }}
          </a-form-item>
          <a-form-item label="标签名称">
            <a-input
              placeholder="请输入标签名称"
              v-decorator="[
                'name',
                {rules: [{required: true, message: '请输入标签名称' }]}
              ]"
            />
          </a-form-item>
          <a-form-item label="标签说明">
            <a-input
              placeholder="请输入标签说明"
              v-decorator="[
                'description'
              ]"
            />
          </a-form-item>
          <a-form-item label="number">
            <a-input-number
              :min="0"
              :max="99999"
              :precision="0"
              style="width: 100%;"
              placeholder="请输入number"
              v-decorator="[
                'number',
                {rules: [
                  { required: true, pattern:/^-?\d+$/, message:'必须输入数字' },
                ]}
              ]"
            />
          </a-form-item>
          <a-form-item label="是否基础标签">
            <a-switch
              :checked-children="true"
              :un-checked-children="false"
              v-decorator="[
              'isBaseTag',
              { rules: [ { required: true }], initialValue: true, valuePropName: 'checked' }
              ]"
            >
            </a-switch>
          </a-form-item>
        </a-form>
      </div>
    </a-spin>
    <template slot="footer">
      <div class="text-r">
        <a-button @click="close">取消</a-button>
        <a-button
          type="primary"
          :disabled="submitLoading"
          :loading="submitLoading"
          @click="submit">
          确定
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
  import { addTag as add, updateTag as update } from 'api/request'
  // import { quoteItemBaseAdd as add, quoteItemBaseUpdate as update } from '@/api/modular/purchase/offerSeting'
  export default {
    data() {
      return {
        visible: false,
        loading: false,
        submitLoading: false,
        parentInfo: {
          id: undefined,
          name: undefined
        },
        form: this.$form.createForm(this),
        id: undefined,
      }
    },
    watch: {
      visible(val) {
        if (!val) {
          this.close()
        }
      }
    },
    deactivated() {
      this.close()
    },
    methods: {
      /** 弹窗显示 */
      show(data = {}) {
        this.visible = true
        let initForm = {
          id: undefined,
          parentId: undefined,
          name: undefined,
          number: undefined,
          isBaseTag: true,
          description: undefined
        }
        if (data.sign) {
          const { currentInfo, parentInfo } = data
          this.id = currentInfo.id
          this.parentInfo = parentInfo
          initForm = {
            name: currentInfo.name,
            number: currentInfo.number,
            isBaseTag: currentInfo.isBaseTag,
            description: currentInfo.description
          }
        }
        console.log(initForm);
        this.initForm(this.form, initForm)
      },
      /** 提交 */
      submit(e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            var params = {
              id: this.id,
              parentId: this.parentInfo.id,
              name: values.name,
              number: values.number,
              isBaseTag: values.isBaseTag,
              description: values.description
            }
            const api = this.id ? update : add
            this.submitLoading = true
            api(params).then(res => {
              if (res) {
                this.$message.success(this.id ? '编辑成功' : '新增成功')
                this.submitLoading = false
                this.$emit('done')
                this.visible = false
              } else {
                this.$message.error(`${this.id ? '编辑' : '新增'}失败` + JSON.stringify(res.message))
              }
            }).finally(res => {
              this.submitLoading = false
            })
          }
        })
      },
      /** 关闭弹窗 */
      close() {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
</script>

<style scoped lang="less">
</style>
